import '@/installCompositionApi'

import hateoasIndex from '@/hateoas-index.js'
import http from '@/helpers/http'
import { mount } from '@/mounter'

import MedicalOfficeSearch from './MedicalOfficeSearch'

const config = window.Sanitas?.SanitasMedicalOfficeSearchConfig || {}

http.createHateoas({
  name: 'api',
  rootEndpoint: hateoasIndex,
  axiosConfig: {
    baseURL: config.apiUrl || '/public',
  },
})

mount('medical-office-search', MedicalOfficeSearch, config)
